module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "cht",
    attrs: {
      "id": "ch_3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    staticClass: "sgc-1",
    attrs: {
      "href": "#/Text/contents#ch3"
    }
  }, [_vm._v("Letter by Masha in Prison")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("March 5, 2012")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('i', [_vm._v("This letter was given to Masha’s friends by one of her lawyers, Nikolai Polozov. It was written when she didn’t have an opportunity to pass letters to anyone. She was later transferred to a more densely populated prison cell")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Second day of pretrial detention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My only cellmate, Nina, and I sleep on metal beds in outdoor clothes. She sleeps in a fur coat; I sleep in a coat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s so cold in the cell that our noses turn red and our feet are ice cold, but we are not allowed to get into bed and under the covers before the bedtime bell. The holes in the window frames are stuffed with hygiene pads and bread crumbs. The sky is all orange from the street lamps at night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve officially stopped my hunger strike so I now drink warm colored water (tea) and eat dry bread three times a day. The flat metal beds are terrifying, it seems easy to smash your head against the edges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nina keeps saying that it won’t get any worse. She’s fifty-five. She got detained for burglary. A drunken policeman took all her stuff and forced her to sign the report incriminating her; she never got to read what she signed. Now she’s a thief in a mask. She’s one of Pussy Riot too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nina told me that her cellmate before me was named Vika. She got handcuffed and raped in a police station, despite her being pregnant. She was only brought to the doctor the next day. The doctor did not diagnose the miscarriage or the rape. Vika is charged with burglary of an unidentified person, that’s what the report says. She’s also a thief in a mask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And yes, she’s one of Pussy Riot too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I still can’t sleep. I got threatened with being transferred to a disciplinary cell for not making up my bed properly today. Here, in the pretrial center, no one knows what a duvet case is, just like in Europe. But everybody knows that you’re a criminal and here for a “good reason.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nina keeps saying it won’t get any worse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We talk about Orwell, Kafka, and the governmental structure. We curse injustice, but despite my encouraging quotes from Foucault, Nina doesn’t believe in change. She "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("keeps saying, “This might be it, but I won’t leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As long as the doctor at the pretrial detention says proudly that he’s been to opposition protests in Bolotnaya Square, as long as the woman in uniform who takes my fingerprints believes in the revolution (though she finds the peacefulness of it pointless)—as long as all those who write about me and who help me feel happy about the changes—I won’t leave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Today is the first day I’ve been able to go for a real walk. During my time out in the tiny square yard between concrete walls, with rusty metal bars on the ceiling, I ran for twenty minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are not allowed to receive any books at Pretrial Detention Number 6; the only book that’s allowed is the Bible, which my mum brought to me this morning. I still haven’t got it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seems like it really won’t get any worse.")]), _vm._v(" "), _c('p', {
    staticClass: "rt"
  }, [_vm._v("—Maria Alyokhina")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e858a42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter3.vue
// module id = 75
// module chunks = 0